import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import api from './http/api'
import fn from './assets/js/global'
import './assets/js/swiper.min.js'
import {Pagination} from 'element-ui';

Vue.component(Pagination.name, Pagination);
import banner from './components/banner'

Vue.component('banner', banner)
Vue.prototype.$api = api
Vue.prototype.$fn = fn
Vue.config.productionTip = false

let vue = new Vue({
    router,
    store,
    render: function (h) {
        return h(App)
    }
}).$mount('#app')
export default vue